/* eslint-disable import/no-cycle */
import { ActionPattern, all, put, select, takeLatest } from 'redux-saga/effects'

import { actions, selectors } from '../index'
import PlanSagas from '../plan/sagas'

export default class PlanningHistorySagas {
  static *init() {
    const plans = yield select(selectors.user.plans)
    if (!plans) {
      yield put(actions.app.setIsLoading(true))
    }
  }

  static *load(action: ReturnType<typeof actions.planninghistory.load>) {
    yield PlanSagas.loadPlans(action?.payload?.page || 1)
    yield PlanSagas.loadReducedCurrentPlan()
    yield put(actions.app.setIsLoading(false))
  }

  static *loadAll() {
    yield PlanSagas.loadFullPlans()
  }

  static *loadMorePlans(
    action: ReturnType<typeof actions.planninghistory.loadMorePlans>
  ) {
    yield PlanSagas.loadPlans(action?.payload?.page || 1)
  }

  static *loop() {
    yield all([
      //
      takeLatest(actions.planninghistory.load as ActionPattern, this.load),
      takeLatest(
        actions.planninghistory.loadAll as ActionPattern,
        this.loadAll
      ),
      takeLatest(
        actions.planninghistory.loadMorePlans as ActionPattern,
        this.load
      ),
    ])
  }
}
